import {
  WalletProvider,
  HippoWalletAdapter,
  AptosWalletAdapter,
  HippoExtensionWalletAdapter,
  MartianWalletAdapter,
  FewchaWalletAdapter,
  PontemWalletAdapter,
  SpikaWalletAdapter,
  RiseWalletAdapter,
  FletchWalletAdapter,
  TokenPocketWalletAdapter,
  ONTOWalletAdapter,
  BloctoWalletAdapter,
  SafePalWalletAdapter,
  FoxWalletAdapter,
  CloverWalletAdapter,
  SpacecyWalletAdapter,
} from "@manahippo/aptos-wallet-adapter";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";

// import MainLayout from './components/Layout/MainLayout'
import MainLayout from "./layouts/Main";
//import './App.css';

const wallets = [
  new HippoWalletAdapter(),
  new MartianWalletAdapter(),
  new AptosWalletAdapter(),
  new FewchaWalletAdapter(),
  new HippoExtensionWalletAdapter(),
  new PontemWalletAdapter(),
  new SpikaWalletAdapter(),
  new RiseWalletAdapter(),
  new FletchWalletAdapter(),
  new TokenPocketWalletAdapter(),
  new ONTOWalletAdapter(),
  new BloctoWalletAdapter({
    bloctoAppId: "6d85f56e-5f2e-46cd-b5f2-5cf9695b4d46",
  }) /** Must provide bloctoAppId **/,
  new SafePalWalletAdapter(),
  new FoxWalletAdapter(),
  new CloverWalletAdapter(),
  new SpacecyWalletAdapter(),
];

interface AppProps {}

const App: React.FC<AppProps> = () => {
  return (
    <WalletProvider
      wallets={wallets}
      autoConnect /** allow auto wallet connection or not **/
      onError={(error: Error) => {
        window.console.log("Handle Error Message", error);
      }}
    >
      {" "}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="App">
          <MainLayout />
        </div>
      </LocalizationProvider>
    </WalletProvider>
  );
};

export default App;
